import { appendEntityToConversation } from './chat-entity-insertion.helper'
import type {
  AddSubAgentChatMessagePayload,
  ChatMessageEntity,
  MessageEntity,
} from './chat-message-entity.interface'
import type { ChatState } from './chat-state.interface'

export const handleAddSubAgentChatMessage = (
  state: ChatState,
  payload: AddSubAgentChatMessagePayload
): void => {
  const existing = state.messageEntities[payload.eventId]
  if (existing) {
    state.messageEntities[existing.id] = buildEntity(payload, existing)
    return
  }
  appendEntityToConversation({
    state,
    conversationId: payload.conversationId,
    entity: buildEntity(payload),
  })
}

const resolveContent = (
  payload: AddSubAgentChatMessagePayload,
  existing?: ChatMessageEntity
): string => {
  if (payload.content) return payload.content
  if (payload.isStreaming) return ''
  return existing?.streamingContent ?? ''
}

const buildEntity = (
  payload: AddSubAgentChatMessagePayload,
  existing?: ChatMessageEntity
): MessageEntity => {
  const isStreaming = payload.isStreaming ?? false
  const now = new Date().toISOString()
  return {
    id: payload.eventId,
    conversationId: payload.conversationId,
    type: 'message',
    sender: 'assistant',
    participant: { id: payload.agentSlug, name: payload.agentLabel },
    content: resolveContent(payload, existing),
    timestamp: existing?.timestamp ?? now,
    turnStartedAt: payload.turnStartedAt ?? existing?.turnStartedAt ?? now,
    agentLabel: payload.agentLabel,
    isPending: false,
    isStreaming,
    streamingContent: isStreaming ? (existing?.streamingContent ?? '') : '',
  }
}
